export default function TypingDot() {
  return (
    <div class="flex items-center">
      <span class="inline-block h-1 w-1 rounded-full bg-gray-500 mr-1 animate-pulse animate-bounce"></span>
      <span class="inline-block h-1 w-1 rounded-full bg-gray-500 mr-1 animate-pulse animate-bounce"></span>
      <span class="inline-block h-1 w-1 rounded-full bg-gray-500 animate-pulse animate-bounce"></span>
    </div>
  );
}
